import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'militaryToAmPm'
})
export class MilitaryToAmPmPipe implements PipeTransform {
	transform(value: string): string {
		if (!value) return '';

		const [hours, minutes] = value.split(':');

		let hour = parseInt(hours, 10);
		const ampm = hour >= 12 ? 'PM' : 'AM';

		if (hour > 12) {
			hour -= 12;
		} else if (hour === 0) {
			hour = 12;
		}

		return `${hour.toString().padStart(2, '0')}:${minutes} ${ampm}`;
	}
}
